<template>
	<div class="formBOX">
		<!-- <div @click="menuClick(snAdd.SystemName)">
			1{{snAdd}}
		</div> -->
		  
		  <el-form :model="snAdd" :rules="rules" ref="snForm" label-width="120px" class="demo-ruleForm">
		  	<el-row>
				<el-col :span="1"></el-col>
		  		<el-col :span="7">
		  			<div class="grid-content bg-purple-light">
		  				<el-form-item label="品牌名称:" prop="BrandID">
		  					<el-select
		  					    v-model="snAdd.BrandID"
		  					    clearable
		  					    placeholder="请选择"
		  					    @change="addProductSelect"
		  					    required  size="small" >
		  					    <el-option
		  					        v-for="item in Data.BrandData"
		  					        :key="item.id"
		  					        :label="item.Name"
		  					        :value="item.id"
		  					    >
		  					    </el-option>
		  					</el-select>
		  				</el-form-item>
		  			</div>
		  		</el-col>
		  	
		  		<el-col :span="7">
		  			<div class="grid-content bg-purple-light">
		  				<el-form-item label="产品类型:" prop="ProductID">
		  					<el-select
		  					    v-model="snAdd.ProductID"
		  					    clearable size="small"
		  					    placeholder="请选择"
		  					    @change="addModelSelect" >
		  					    <el-option
		  					        v-for="item in Data.ProductData"
		  					        :key="item.id"
		  					        :label="item.Name"
		  					        :value="item.id" >
		  					    </el-option>
		  					</el-select>
		  				</el-form-item>
		  			</div>
		  		</el-col>
		  		
		  		<el-col :span="7">
		  			<div class="grid-content bg-purple-light">
		  				<el-form-item label="产品型号:" prop="ModelNoId">
		  					<el-select
		  					    v-model="snAdd.ModelNoId"
		  					    clearable size="small"
		  					    placeholder="请选择"
		  					    @change="" >
		  					    <el-option
		  					        v-for="item in Data.modelData"
		  					        :key="item.id"
		  					        :label="item.Name"
		  					        :value="item.id"
		  					    >
		  					    </el-option>
		  					</el-select>
		  				</el-form-item>
		  			</div>
		  		</el-col>
			</el-row>
			
		  	<el-row>
				<el-col :span="1"></el-col>
		  		<el-col :span="7">
		  			<div class="grid-content bg-purple">
		  				<el-form-item label="合同号:" prop="ContractId">
		  					<el-input v-model="snAdd.ContractId" disabled size="small"></el-input>
		  				</el-form-item>
		  			</div>
		  		</el-col>
		  	
		  		<el-col :span="7">
		  			<div class="grid-content bg-purple">
		  				<el-form-item label="系统:" prop="SystemName">
		  					<el-input v-model="snAdd.SystemName" size="small"></el-input>
		  				</el-form-item>
		  			</div>
		  		</el-col>
		  		
		  		<el-col :span="7">
		  			<div class="grid-content bg-purple">
		  				<el-form-item label="Fusion版:" prop="Fusion">
		  					<el-input v-model="snAdd.Fusion" size="small"></el-input>
		  				</el-form-item>
		  			</div>
		  		</el-col>
			</el-row>
			
			<el-row>
				<el-col :span="1"></el-col>
		  		<el-col :span="7">
		  			<div class="grid-content bg-purple">
		  				<el-form-item label="MAC地址:" prop="MACAddr">
		  					<el-input v-model="snAdd.MACAddr" size="small"></el-input>
		  				</el-form-item>
		  			</div>
		  		</el-col>
		  		
		  		<el-col :span="7">
		  			<div class="grid-content bg-purple">
		  				<el-form-item label="IP地址:" prop="IPAddr">
		  					<el-input v-model="snAdd.IPAddr" size="small"></el-input>
		  				</el-form-item>
		  			</div>
		  		</el-col>
		  		
		  		<el-col :span="7">
		  			<div class="grid-content bg-purple">
		  				<el-form-item label="网关掩码DNS:" prop="DNSAddr">
		  					<el-input v-model="snAdd.DNSAddr" size="small"></el-input>
		  				</el-form-item>
		  			</div>
		  		</el-col>
			</el-row>
			
			<el-row>
				<el-col :span="1"></el-col>
		  		<el-col :span="7">
		  			<div class="grid-content bg-purple">
		  				<el-form-item label="LicenseeName:" prop="Licensee">
		  					<el-input v-model="snAdd.Licensee" size="small"></el-input>
		  				</el-form-item>
		  			</div>
		  		</el-col>
		  		<el-col :span="7">
		  			<div class="grid-content bg-purple">
		  				<el-form-item label="Wavelink注册信息:" label-width="150px" prop="RegeditInfo">
		  					<el-input v-model="snAdd.RegeditInfo" size="small"></el-input>
		  				</el-form-item>
		  			</div>
		  		</el-col>
		  		<el-col :span="7">
		  			<div class="grid-content bg-purple">
		  				<el-form-item label="是否巡检:" prop="State">
		  					<el-checkbox v-model="snAdd.State" label="uploadFile">
		  						{{ snAdd.State===true ? ' ' : ' '}}
		  					</el-checkbox>
		  				</el-form-item>
		  			</div>
		  		</el-col>
		  	</el-row>
		  		
		  	<el-row>
				<el-col :span="1"></el-col>
		  		<el-col :span="14">
		  			<el-form-item label="SN:" prop="Name">
		  					<el-input type="textarea" v-model="snAdd.Name"></el-input>
		  			</el-form-item>
		  		</el-col>
		  		<el-col :span="7">
		  			<el-form-item label="不递送:" prop="NotExpress">
		  				<el-checkbox v-model="snAdd.NotExpress" label="uploadFile">
		  					{{ snAdd.NotExpress === true ? ' ' : ' '}}
		  				</el-checkbox>
		  			</el-form-item>
		  		</el-col>
		  	</el-row>
		  	
		  	<el-row class="snSaveFormbTN">
		  		  <el-col :span="10"><div class="grid-content bg-purple"></div></el-col>
		  		  <el-col :span="4"><div class="grid-content bg-purple saveBTN">
		  			<add-button type="primary" @click="submitForm('snForm')">保存</add-button>
		  		  </div></el-col>
		  		  <el-col :span="10"><div class="grid-content bg-purple-light"></div></el-col>
		  	</el-row>
		  </el-form>
		
	</div>
</template>
<script>
	import {
		defineComponent,
		reactive,
		toRefs,
		ref,
		onMounted,
		computed,
		nextTick,
		watch
	} from "vue"
	import tableApi from "@/api/tabel.js"
	import addButton from "@/components/addButton.vue"
	export default defineComponent({
		name: 'popForm',
		components: {
			addButton
		},
		props: {
			snAdd: { // 数据
				type: Object,
				default: null
			}
		},
		setup(props, context) {
			
			const ruleFormsss = ref(null);
			const snForm = ref(null);
			
			const Data = reactive({
			  BrandData: null,
			  ProductData: null,
			  modelData: null,
			})
			
			const ruleForm = reactive({
				cycle: null, 				// cycle	Decimal	周期	-
				CompanyId: null, 		// CompanyId	int	客户Id	是-
				DicInfoId: null, 		// DicInfoId	int	合同类型id	是
				ContractNo: '', 		// ContractNo	String	合同号	是
				BuyDate: '', 			// BuyDate	String	购买日期	是
				EndDate: '', 			// EndDate	String	截止日期	是
				rimDate: '', 			// rimDate	String	提醒日期	
				Month: null, 			// Month	Int	月限	是
				Appendix: '', 			// Appendix	String	备注	
				sn: '', 	 			// sn	String	SN号	是
				mid: null, 				// mid	Int	型号Id	是
				companyArray: [], 		// companyArray	String	服务公司	
				notExpress: false	 	// notExpress	Bool	是否递送	
			})
			const rules = {
			  cycle: [
				{ required: true, message: '请输入', trigger: 'blur' },
				// { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
			  ] ,
			  CompanyId: [
				{ required: true, message: '请输入', trigger: 'blur' },
			  ] ,
			  DicInfoId: [
				{ required: true, message: '请输入', trigger: 'blur' },
			  ] ,
			  ContractNo: [
				{ required: true, message: '请输入', trigger: 'blur' },
			  ] ,
			  BuyDate: [
				{ required: true, message: '请输入', trigger: 'blur' },
			  ] ,
			  EndDate: [
				{ required: true, message: '请输入', trigger: 'blur' },
			  ] ,
			  Month: [
				{ required: true, message: '请输入', trigger: 'blur' },
			  ] ,
			  sn: [
				{ required: true, message: '请输入', trigger: 'blur' },
			  ] ,
			  mid: [
				{ required: true, message: '请输入', trigger: 'blur' },
			  ]
			}
			// SN号添加
			const snAdd = reactive({
				ModelNoId: null, 		// ModelNoId	int	型号Id	是
				ContractId: null,		// ContractId	int	合同Id	是
				compid: null,			// compid	int	公司Id	
				NotExpress: false,		// NotExpress	Bool	是否递送	
				Name: '',					// Name	string	SN号	是
				ContractName: '',			// ContractName	string	合同号	是
				SystemName: '',				// SystemName	string	系统	
				Fusion: '',					// Fusion	string	Fusion版本	
				MACAddr: '',				// MACAddr	string	MAC地址	
				IPAddr: '',					// IPAddr	string	IP地址	
				DNSAddr: '',				// DNSAddr	string	网关掩码DNS	
				Licensee: '',				// Licensee	string	LicenseeName	
				RegeditInfo: '',			// RegeditInfo	string	Wavelink注册信息	
				State: false,		// State	Bool	是否巡检	
			})
			
			function menuClick(menuName) {
				// 通过自定义事件回传值
				context.emit('menuClick', {
					menuName
				})
			}

			let methods = {
				// sn添加保存
				snSaveForm(menuName) {
					context.emit('snSaveForm', snAdd)
				},
				submitForm(formName) {
					this.$refs[formName].validate((valid) => {
						if (valid) {
							console.log(ruleForm)
							context.emit('snSaveForm', snAdd)
						} else {
							console.log('error submit!!');
							return false;
						}
					})
				},
				companyAdd() {
					// 品牌
				    tableApi.BrandSelect().then((data) => {
				        if (data.code == 0) {
				            Data.BrandData = data.data.list;
				        } else {
				        }
				    })
				},
				// 类型
				addProductSelect() {
				    let Bid = snAdd.BrandID;
				    tableApi.ProductSelect({ Bid }).then((data) => {
				        if (data.code == 0) {
				            Data.ProductData = data.data.list;
				        } else {
				        }
				    });
				},
				// 型号
				addModelSelect() {
				    let ProductCategoryId = snAdd.BrandID;
				    tableApi.modelSelect({ ProductCategoryId }).then((data) => {
				        if (data.code == 0) {
				            Data.modelData = data.data.list;
				        } else {
				        }
				    })
				},
			}
			
			onMounted(methods.companyAdd)

			return {
				ruleForm,
				rules,
				snAdd,
				Data,
				// ...toRefs(data),
				// menuClick,
				...methods
			}
		}
	})
</script>
<style lang='scss'>
	.formBOX {
		width: 100%;
		height: 100%;
		margin: 0;
		padding: 0;
		
		.el-select{
			width: 100%;
		}
		.snSaveFormbTN{
			text-align: center;
		}
	}

	.mactive {
		color: white;
		font-weight: bold;
	}
</style>
